import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getUsersByGroupId } from '../../services/GroupsService';
import { FeaturesManagement } from '../../../featuresControl';
import { UsersResponse } from '../../types/Users';

function useGetUsersByGroupById(id: string, fleetId: string, query = '', enabled: boolean = true): UseQueryResult<UsersResponse> {
  return useQuery(
    ['group-users', id, fleetId],
    async (): Promise<UsersResponse> => getUsersByGroupId(id, fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: !!id && enabled,
    },
  );
}

export default useGetUsersByGroupById;
